module.exports = __webpack_public_path__ + "static/media/Eclipse.ba4a199c.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Eclipse.gif
// module id = 1137
// module chunks = 0